import { convertToFirstLetterCapital } from '../../../../../utils/utils';
import type { Case } from './legalCasesType';
import { CASE_TYPE_LABEL, CaseTypeCategory } from './caseTypeCategory';

export const CASE_CATEGORY_SUFFIX = 'Cases';

export type CaseCategoryTone = 'civil' | 'criminal' | 'neutral';

const usableCategory = (value?: string | null): string | undefined => {
    const category = value?.trim();
    return category && category.toUpperCase() !== CaseTypeCategory.OTHER ? category : undefined;
};

export const caseCategoryOf = (row?: Pick<Case, 'caseDetails' | 'caseTypeCategory'> | null): string | undefined =>
    usableCategory(row?.caseDetails?.standardCaseTypeCategoryVendor) ??
    usableCategory(row?.caseDetails?.civilCriminal) ??
    usableCategory(row?.caseTypeCategory && CASE_TYPE_LABEL[row.caseTypeCategory]);

export const caseCategoryLabel = (caseCategory?: string): string | undefined =>
    caseCategory ? `${convertToFirstLetterCapital(caseCategory)} ${CASE_CATEGORY_SUFFIX}` : undefined;

export const caseCategoryTone = (caseCategory?: string): CaseCategoryTone => {
    const normalised = caseCategory?.trim().toLowerCase();
    if (normalised === 'civil') return 'civil';
    if (normalised === 'criminal') return 'criminal';
    return 'neutral';
};
